import { createContext } from "react";
import { Endpoints } from "../../lib/endpoints";
import { usePerformRequest } from "../../lib/usePerformRequest";
import { NonPaginatedResponse } from "../../types";
import { IAvailableLoanPlansProps } from "../../types/Loan";


export interface AppContextType {
     availableLoanPlans: IAvailableLoanPlansProps[];
     isLoading: boolean;
     reloadData: () => void;
}
export const AppContext = createContext<AppContextType>({
     availableLoanPlans: [],
     isLoading: false,
     reloadData: () => {},
});
export default function AppContextProvider({ children }: { children: React.ReactNode }) {
     const {data, isLoading, reloadData} = usePerformRequest<NonPaginatedResponse<IAvailableLoanPlansProps[]>>({
          method: Endpoints.GetAvailableLoanPlans().method,
          route: Endpoints.GetAvailableLoanPlans().route,
     })

     return (
          <AppContext.Provider value={{
               availableLoanPlans: data?.data || [],
               isLoading,
               reloadData,
          }}>
               {children}
          </AppContext.Provider>
     )
}